import React from "react";

import { Button, Input, Modal, Form, Select } from "antd";
import { MobileNotification } from "utils/interfaces";
import { Control, Controller, FieldErrors, SubmitHandler, UseFormHandleSubmit } from "react-hook-form";
import TextArea from "antd/es/input/TextArea";
// utils

interface MobileNotificationCreateModalProps {
  showCreateMobileNotificationModal: boolean,
  toggleCreateMobileNotificationModal: (makeVisible: boolean) => void,
  handleSubmit: UseFormHandleSubmit<MobileNotification, MobileNotification>,
  errors: FieldErrors<MobileNotification>,
  onSubmit: SubmitHandler<MobileNotification>,
  control: Control<MobileNotification, any, MobileNotification>,
  isValid: boolean,
  isSubmitting: boolean
}

const MobileNotificationCreateModal: React.FC<MobileNotificationCreateModalProps> = ({
  showCreateMobileNotificationModal,
  toggleCreateMobileNotificationModal,
  handleSubmit,
  errors,
  onSubmit,
  control,
  isValid,
  isSubmitting
}) => {

  const typeOptions = [
    {
      label: 'FIRMWARE_UPDATE',
      value: 'FIRMWARE_UPDATE'
    },
    {
      label: 'NEW_CONFIG_AVAILABLE',
      value: 'NEW_CONFIG_AVAILABLE'
    }
  ]
  return (
    <Modal
      title={'Create Mobile Notification'}
      open={showCreateMobileNotificationModal}
      onCancel={() => toggleCreateMobileNotificationModal(false)}
      closable={!isSubmitting}
      mask={{ closable: !isSubmitting }}
      footer={[
        <Button onClick={() => toggleCreateMobileNotificationModal(false)} disabled={isSubmitting}>Cancel</Button>,
        <Button
          onClick={handleSubmit(onSubmit)}
          type="primary"
          disabled={!isValid || isSubmitting}
          loading={isSubmitting}
        >Create</Button>
      ]}
    >
      <Form layout="vertical" preserve={false}>
        <Form.Item
          label="Notification Title"
          validateStatus={errors.title ? "error" : ""}
          help={errors.title?.message}
        >
          <Controller
            name="title"
            control={control}
            rules={{required: "Title is required!"}}
            render={({ field }) => (
              <Input {...field} placeholder="Enter title..." />
            )}
          />
        </Form.Item>
        <Form.Item
          label="Notification Body"
          validateStatus={errors.body ? "error" : ""}
          help={errors.body?.message}
        >
          <Controller
            name="body"
            control={control}
            rules={{required: "Body is required!"}}
            render={({ field }) => (
              <TextArea {...field} placeholder="Enter body..." />
            )}
          />
        </Form.Item>
        <Form.Item
          label="Type"
          validateStatus={errors.type ? "error" : ""}
          help={errors.type?.message}
        >
          <Controller
            name="type"
            control={control}
            rules={{ required: "Please type!" }}
            render={({ field }) => (
              <Select
                {...field}
                placeholder="Select Type"
                options={typeOptions.map((type) => ({
                  label: type.label,
                  value: type.value
                }))}
              />
            )}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
export default MobileNotificationCreateModal;
